import React from 'react';
import PropTypes from 'prop-types';
import {TableCell, TableRow} from "@mui/material";
import Skeleton from "@mui/material/Skeleton";

const SkeletonRow = ({ rowKey, columnsCount = 0 }) => {
    const columns = [];
    for (let i = 0; i < columnsCount; i++) {
      columns.push(
        <TableCell key={`skeleton-${rowKey}-${i}`}>
          <Skeleton />
        </TableCell>
      );
    }
    return (
      <TableRow
        key={rowKey}
        sx={{
          "&:last-child td, &:last-child th": { border: 0 },
          "&:hover": { cursor: "pointer" },
        }}
      >
        {columns}
      </TableRow>
    );
  };  

SkeletonRow.propTypes = {

};

export default SkeletonRow;
